<template>
	<div class="app-floating-boxes"></div>
</template>

<script>
import uniqueid from '@/utils/uniqueid'
import FloatingBox from './FloatingBox'
export default {
	components: {
		FloatingBox
	},
	data () {
		return {
			boxes: []
		}
	},
	methods: {
		createBox (box) {
			this.$appToast.show(box)
		},
		removeBox (box) {
			const jsonBox = JSON.stringify(box)
			this.boxes = this.boxes.filter(element => JSON.stringify(element) !== jsonBox)
		},
		onAddBox (box) {
			this.createBox(box);
		},
		onClose (box) {
			this.removeBox(box)
		}
	},
	mounted () {
		this.$root.$on('add-floating-box', this.onAddBox)
	},
	beforeDestroy () {
		this.$root.$off('add-floating-box', this.onAddBox)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/boxes/FloatingBoxes.vue